module.exports = __webpack_public_path__ + "static/img/pc.b52215f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/国际高中/pc.svg
// module id = j3Hh
// module chunks = 16